
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PointOfSaleMailbox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EX_POS_PointOfSale"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mailbox"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"host"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"port"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"auth_method"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_oauth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_oauth_connected"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oauth_client_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oauth_tenant_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mailgun_webhook_signing_key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imap_enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imap_host"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imap_port"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imap_username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imap_encryption"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"validation_status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_validated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_faulty"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imap_validation_status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_imap_validated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_imap_faulty"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"has_dedicated_imap_password"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"defaultSignature"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"points_of_sale"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultSignature"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":791}};
    doc.loc.source = {"body":"fragment PointOfSaleMailbox on EX_POS_PointOfSale {\n    mailbox {\n        id\n        type\n        host\n        port\n        username\n        address\n        name\n        auth_method\n        is_oauth\n        is_oauth_connected\n        oauth_client_id\n        oauth_tenant_id\n        mailgun_webhook_signing_key\n        imap_enabled\n        imap_host\n        imap_port\n        imap_username\n        imap_encryption\n        validation_status\n        is_validated\n        is_faulty\n        imap_validation_status\n        is_imap_validated\n        is_imap_faulty\n        has_dedicated_imap_password\n        defaultSignature {\n            id\n            name\n        }\n        points_of_sale {\n            id\n            name\n        }\n    }\n    defaultSignature {\n        id\n        name\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["PointOfSaleMailbox"] = oneQuery(doc, "PointOfSaleMailbox");
        
